import type { ComponentProps } from 'react';
import { OwcTag } from '@one/react';

export type PocTagProps = ComponentProps<typeof OwcTag>;

export const PocTag: React.FC<PocTagProps> = (props) => <OwcTag {...props} />;
